import { z } from 'zod';
const instant = z.string().datetime({ offset: true });
/** A call or a WhatsApp the broker types in by hand: a name, a number, maybe a flat, a note and a follow up. */
export const createEnquirySchema = z.object({
    name: z.string().trim().min(2).max(80),
    phone: z.string().trim().min(1).max(20),
    propertyId: z.string().uuid().nullable().optional(),
    note: z.string().trim().max(500).nullable().optional(),
    followUpAt: instant.nullable().optional(),
});
export const updateEnquirySchema = z
    .object({
    note: z.string().trim().max(500).nullable().optional(),
    followUpAt: instant.nullable().optional(),
    propertyId: z.string().uuid().nullable().optional(),
    status: z.enum(['open', 'closed']).optional(),
})
    .refine((v) => Object.keys(v).length > 0, 'Provide at least one field');
/** Turns an enquiry into a visit on its flat; a time in words, or the broker calls to fix one. */
export const enquiryVisitSchema = z.object({
    slot: z.string().trim().min(1).max(60).optional(),
});
//# sourceMappingURL=enquiry.js.map